import { lazy } from 'react'
import { defineGrowthEvent } from '~/features/GrowthEvent/common/framework'

/*
 * Define the config type
 */
declare module '~/features/GrowthEvent/common/growthEventConfig' {
  interface DynamicGrowthEvents {
    /**
     * Example event config.
     * DO NOT USE IN PRODUCTION
     */
    exampleEvent?: EventBasicConfig & {
      countdown?: Array<{
        enabled?: boolean
        startDate?: string
        endDate?: string
      }>
    }
  }
}

export default defineGrowthEvent({
  id: 'exampleEvent',
  eventRoute: 'example',
  EventPage: lazy(() => import('./EventPage')),
  SlotContents: lazy(() => import('./SlotContents')),
})
